var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OfMultiSelect',{attrs:{"required":"","name":_vm.name,"label":_vm.label,"options":_vm.options,"multiple":_vm.multiple}})}
var staticRenderFns = []

export { render, staticRenderFns }